const FnUtil = {
  maxCalls(fn, maxCount) {
    let count = 0;
    return function(...args) {
      if (count >= maxCount) {
        return undefined;
      }
      count += 1;
      return fn.apply(this, args);
    };
  },
};

export default FnUtil;
